import { userSegRedirectEntrypoint } from '@jira/redirect-entrypoints__user-seg-redirect/src/userSegRedirectEntrypoint.entrypoint.tsx';
import { nextGenBacklogEntryPoint } from '@jira/spa-apps__next-gen-backlog/src/nextGenBacklogEntryPoint.entrypoint.tsx';
import type { TenantContext } from '@jira/platform__tenant-context-types/src/tenant-context.tsx';
import type {
	JSResourceReference,
	EntryPointComponent,
	PreloadProps,
	EntryPoint,
} from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { jiraHorizontalNavEntrypoint } from '@jira/navigation-apps__horizontal-nav-jira/src/jiraHorizontalNavEntrypoint.entrypoint.tsx';
// eslint-disable-next-line jira/restricted/@atlassian+jira-entry-point
import type { AnyEntryPoint } from '@jira/platform__entry-point/src/common/types.tsx';
import type { RouterContext } from '@atlassian/react-resource-router';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';

export const backlogPageEntrypoint: {
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	root: JSResourceReference<EntryPointComponent<any, any, any, any> | null>;
	getPreloadProps: (entryPointParams: EntryPointRouteParams) => {
		entryPoints: {
			___pageLayoutRedirect?:
				| {
						entryPoint: AnyEntryPoint;
						entryPointParams: EntryPointRouteParams;
				  }
				| undefined;
			__pageLayoutRightSidebar?:
				| {
						entryPoint: AnyEntryPoint;
						entryPointParams: {
							fallback: (() => JSX.Element) | undefined;
							context: RouterContext;
							tenantContext: TenantContext;
						};
				  }
				| undefined;
			__pageLayoutHorizontalNavigation?:
				| {
						entryPoint: AnyEntryPoint;
						entryPointParams: {
							fallback: (() => JSX.Element) | undefined;
							context: RouterContext;
							tenantContext: TenantContext;
						};
				  }
				| undefined;
			__pageLayoutPreviewPanel?:
				| {
						entryPoint: AnyEntryPoint;
						entryPointParams: EntryPointRouteParams;
				  }
				| undefined;
			__pageLayoutLeftSidebar?:
				| {
						entryPoint: AnyEntryPoint;
						entryPointParams: {
							entryPoints: {
								[x: string]: {
									entryPoint: AnyEntryPoint;
									entryPointParams: EntryPointRouteParams;
								};
							};
							isAppsExpanded: boolean;
							isFiltersExpanded: boolean;
							isPlansExpanded: boolean;
							isProjectsExpanded: boolean;
							isOperationsExpanded: boolean;
							context: RouterContext;
							tenantContext: TenantContext;
						};
				  }
				| undefined;
			__pageLayoutMainContent: {
				entryPoint: Readonly<{
					getPreloadProps: (
						entryPointParams: EntryPointRouteParams, // oxlint-disable-next-line @typescript-eslint/no-explicit-any
					) => PreloadProps<EntryPointRouteParams, any, any, any>;
					// oxlint-disable-next-line @typescript-eslint/no-explicit-any
					root: JSResourceReference<EntryPointComponent<any, any, any, any> | null>;
				}>;
				entryPointParams: EntryPointRouteParams;
			};
			__pageLayoutTopNavigation: {
				entryPoint: EntryPoint<
					EntryPointComponent<
						Record<string, OperationType>,
						// oxlint-disable-next-line @typescript-eslint/no-explicit-any
						Record<string, EntryPoint<any, any> | undefined>,
						{},
						{} | null
					>,
					{}
				>;
				entryPointParams: EntryPointRouteParams;
			};
		};
	};
	toString: () => string;
} = createPageEntryPoint({
	main: nextGenBacklogEntryPoint,
	horizontalNavigation: jiraHorizontalNavEntrypoint,
	redirect: userSegRedirectEntrypoint,
});
